import Vue from 'vue';
export default class fvAlarmServer {
    constructor(parent,options){
        this.system = parent;
        this.options = options.config;
        this.db = parent.dbCom;  
        this.objName = options.config.name
        this.sig = "";
        this.sig1 = "";
        //根据选择文件播放声音
        document.getElementById('audioOpen').setAttribute('src',debugFWebView + this.system.$store.state.system.$.projectName+"/Audio/"+options.config.AlamAudio);
        this.onSocketClient(parent)
        this.stringFun()
        // options.AlamAudio
        //设置声音
        if(options.config.openView=="" ||options.config.openView == undefined){
            document.getElementById('confirmAll').disabled = true;
        } 
    }
    //监听报警数据
    onSocketClient(parent){
        parent.dbCom.socketClient.on('message', function(msg){
            switch(msg.head){
                case "backAlarmServer":
                    if(msg.message.data.length>0){
                        this.sig = "";
                        //console.log(msg.message.data)
                        for(var k in msg.message.data){
                            this.sig +=msg.message.data[k].alarmId+",";
                        }
                        var box = document.getElementById('promptBox');
                        var bodyDom = document.getElementById('bodyBox');
                        if(this.sig != this.sig1){
                            this.sig1 = this.sig;
                            box.classList.remove("closeBoxStyle")
                            box.classList.add("showBox")
                            // 开启声音
                            var html = "";
                            var data = [];
                            for(var k in msg.message.data){
                                if(msg.message.data[k].needAck){
                                    if(msg.message.data[k].haveAcked){
                                    }else{
                                        data.push(msg.message.data[k])
                                    }
                                }
                            }
                            this.alarmRes = data;
                            html +="<span style='color:red;font-size: 16px;'> 当前报警："+data.length+"条;</span>" 
                            bodyDom.innerHTML = html;
                            var ao = document.getElementById('audioOpen')
                            ao.play();
                            if(data.length<1){
                                //关闭提示框
                                document.getElementById('audioOpen').pause();
                                var box = document.getElementById('promptBox');
                                box.classList.add("closeBoxStyle");
                            }
                        }else{
                            var html = "";
                            var data = [];
                            for(var k in msg.message.data){
                                if(msg.message.data[k].needAck){
                                    if(msg.message.data[k].haveAcked){
                                    }else{
                                        data.push(msg.message.data[k])
                                    }
                                }
                            }
                            this.alarmRes = data;
                            html +="<span style='color:red;font-size: 16px;'> 当前报警："+data.length+"条;</span>" 
                            bodyDom.innerHTML = html;
                            if(data.length<1){
                                //关闭提示框
                                document.getElementById('audioOpen').pause();
                                var box = document.getElementById('promptBox');
                                box.classList.add("closeBoxStyle");
                            }
                        }
                    }else{
                        //关闭提示框
                        document.getElementById('audioOpen').pause();
                        var box = document.getElementById('promptBox');
                        box.classList.add("closeBoxStyle");
                    }
                break;
            }
        }.bind(this)) 
    }
    //报警提示框按钮
    stringFun(){
        //关闭按钮
        var close = document.getElementById('closeBox');
        close.addEventListener('click', (e)=> {  
            var box = document.getElementById('promptBox')
            box.classList.add("closeBoxStyle")
            if(this.alarmRes.length>0){
                //显示提示按钮
                var showAL = document.getElementById('showAL');
                showAL.style.display= "block";
            }
        })
        //显示
        var close = document.getElementById('showAL');
        close.addEventListener('click', (e)=> {  
            var box = document.getElementById('promptBox')//
            var bodyDom = document.getElementById('bodyBox')
            box.classList.remove("closeBoxStyle")
            box.classList.add("showBox")
        })
        //开启声音
        var off = document.getElementById('soundOff');
        off.addEventListener('click', function(e) { 
            var ao = document.getElementById('audioOpen')
            var on = document.getElementById('soundOn')
            on.setAttribute('style', 'display: inline-block');
            off.setAttribute('style', 'display: none');
            ao.muted=false;
            if(this.alarmRes.length>0){
                ao.play();
            }
        }.bind(this))
        //静音
        var on = document.getElementById('soundOn');
        on.addEventListener('click', function(e) { 
            var off = document.getElementById('soundOff');
            var ao = document.getElementById('audioOpen')
            on.setAttribute('style', 'display: none');
            off.setAttribute('style', 'display: inline-block');
            ao.muted=true;
        })
        //点击确认按钮
        var all = document.getElementById('confirmAll');
        all.addEventListener('click', function(e) { 
            var list = [];
            for(var k in this.alarmRes){
                //this.getAlarmData(this.alarmRes[k])
                list.push(parseInt(this.alarmRes[k].alarmId))
            }
            this.getAlarmData(list)
        }.bind(this))
    }
    //查看报警 跳转到报警页面
    getAlarmData(value){
        this.system.$store.state.system.manager.$.openView(this.options.openView);
        //停止声音
        document.getElementById('audioOpen').pause();
        //隐藏提示框
        var box = document.getElementById('promptBox');
        box.classList.add("closeBoxStyle");
        // var data = {
        //     "head": "dataLayer",
        //     "message" :  {
        //         "head" : "makeConfirmSourceAlarm",
        //         "message" : {
        //             "head" : "makeConfirm Alarm",
        //             "ackName" : "admin",//确认人
        //             "alarmIds" : [value]//确认id
        //         }
        //     }
        // }
        // return new Promise((resolve,reject) => {
        //     this.db.sendMessage(data,(err,result) => {
        //         if(err){
        //             reject(err);
        //         }else{
        //             //确认后停止声音
        //             var ao = document.getElementById('audioOpen')
        //             ao.pause();
        //             //隐藏提示框
        //             var box = document.getElementById('promptBox')
        //             box.classList.add("closeBoxStyle")
        //         resolve(result);
        //         }
        //     })
        // })
    }
}


// WEBPACK FOOTER //
// ./src/js/backstage/fvAlarmServer/index.js